(() => {
  const data = navigator.connection;
  const blocked = () => data?.saveData || /2g/.test(data?.effectiveType || '');
  const debug = /[?&]tbhero/.test(location.search) && document.body.appendChild(Object.assign(document.createElement('pre'), { style: 'position:fixed;left:8px;bottom:8px;z-index:99999;margin:0;padding:6px;background:#000;color:#0f0;font:11px monospace;white-space:pre-wrap' }));
  const log = (s) => { if (debug) debug.textContent += s + '\n'; };
  document.querySelectorAll('[data-tb-hero-video]').forEach((video) => {
    const box = video.parentElement, img = box.querySelector('img');
    let visible = !('IntersectionObserver' in window), ready = false, failed = false, ended = false;
    const toEnd = () => { video.classList.add('is-off'); box.querySelectorAll('[data-tb-end]').forEach((el) => { el.srcset = el.dataset.tbEnd; }); };
    const toAnim = (why) => {
      failed = true; log('fallback ' + why);
      video.pause(); video.classList.add('is-off');
      box.querySelectorAll('picture source').forEach((el) => el.remove());
      img.srcset = ''; img.src = video.dataset.anim;
    };
    const update = () => {
      if (!ready || failed || ended) return;
      if (!video.src && blocked()) { failed = true; log('blocked'); toEnd(); return; }
      if (!visible || document.hidden) { video.pause(); return; }
      if (!video.src) {
        video.poster = img.currentSrc;
        const width = video.getBoundingClientRect().width * (window.devicePixelRatio || 1);
        video.preload = 'auto';
        video.src = window.innerWidth > 600 && width > 720 ? video.dataset.src1080 : video.dataset.src720;
        video.classList.add('is-on');
        log('src ' + video.src.split('/').pop().split('?')[0]);
        // iOS solo deja arrancar un video que ya se ve: primero se pinta con el póster (igual a la imagen), después play
        return window.requestAnimationFrame(() => setTimeout(play, 0));
      }
      play();
    };
    const play = () => {
      if (failed || ended || !visible || document.hidden) return;
      video.play().then(() => log('play ok'), (error) => {
        if (error.name !== 'AbortError') toAnim(error.name);
      });
    };
    video.addEventListener('playing', () => { log('playing'); if (!visible || document.hidden) update(); });
    video.addEventListener('ended', () => { ended = true; log('ended'); });
    video.addEventListener('error', () => toAnim('error ' + (video.error && video.error.code)));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; update(); }).observe(video);
    }
    document.addEventListener('visibilitychange', update);
    data?.addEventListener('change', update);
    window.addEventListener('pageshow', (event) => {
      if (event.persisted && video.src && !failed) { ended = false; video.currentTime = 0; update(); }
    });
    const start = () => window.requestAnimationFrame(() => setTimeout(() => { ready = true; log('ready'); update(); }, 0));
    if (img.complete) start();
    else { img.addEventListener('load', start, { once: true }); img.addEventListener('error', start, { once: true }); }
  });
})();
